import React, { useRef, useState } from 'react'
import { ReactComponent as IconDeleteProduct } from '../../assets/images/icons/icon-delete.svg'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { buyermanagement, userManagement } from '../../config/routingConsts'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import VendorProductTab from '../../components/TabsForVendors/VendorProductTab'
import VendorOrderTab from '../../components/TabsForVendors/VendorOrderTab'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import VendorReviewTab from '../../components/TabsForVendors/VendorReviewTab/VendorReviewTab'
import DummyUserImage from '../../assets/images/user-profile.png'
import FeesModal from '../../components/FeesModal/FeesModal'

//#region  API Call for view Vendor Data
const vendorViewDetail = async (userId) => {
    return await requestApi
        .post(`user/view`, { userId }, { headers: true })
        .then((res) => {
            return res.data
        })
}
//#endregion

const ViewBuyerDetails = () => {
    const [editbtn, seteditbtn] = useState(false)

    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState('orders')
    const { userId } = useParams()
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteId, setDelteId] = useState('')
    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)

    const { data, isLoading } = useQuery({
        queryKey: ['vendor-view'],
        queryFn: () => vendorViewDetail(userId),
        enabled: !!userId,
        onSuccess: (data) => {
            //     reset({
            //         size:data?.data?.name
            //     })
        },
        onError: (error) => {
            console.log(error.message)
        }
    })

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex)
    }

    //#region  Delete user(Seller) by ID
    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    function handleDelete(userId) {
        mutationDelete.mutate(userId)
        setIsDeleteModal(false)
        navigate(buyermanagement)
    }

    async function deleteUserById(userId) {
        return await requestApi.post(`user/delete`, {
            userId
        })
    }

    const mutationDelete = useMutation(deleteUserById, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('userList')
            setIsDeleteModal(false)
            EditDataRef.current = null
        },
        onError: () => {
            EditDataRef.current = null
        }
    })
    //#endregion
   
    const [getFees, setFees] = useState('')
    const handleEditBtn = (fees) => {
        seteditbtn(true)
        setFees(fees)
    }

    return (
        <>
            <div className="view-product-details view-buyer-details">
                <ul className="site-breadcrumb">
                    <li>
                        <Link to={buyermanagement}>Buyer Management</Link>
                    </li>
                    <li>Buyer Detail</li>
                </ul>
                <div className="admin-card">
                    <div className="head">
                        <h2>Buyer Detail</h2>
                        <div
                            className="delete-btn"
                            onClick={() => handleDeleteModal(userId)}
                        >
                            <IconDeleteProduct />
                        </div>
                    </div>
                </div>
                <div className="admin-card product-details-card buyer-profile-detail">
                    <div className="image-wrapper">
                        {data?.data?.profilePic ? (
                            <img src={data?.data?.profilePic} alt="user" />
                        ) : (
                            <img src={DummyUserImage} alt="user" />
                        )}
                        <p>Buyer Name</p>
                        <h6>
                            {data?.data?.firstName ? data?.data?.firstName : '-'}
                        </h6>
                    </div>
                    <ul className="product-details-list justify-content-start">
                       
                        <li>
                            <span>Email address</span>
                            {data?.data?.email ? data?.data?.email : '-'}
                        </li>
                        <li>
                            <span>Phone No.</span>
                            {data?.data?.phoneNo ? data?.data?.phoneNo : '-'}
                        </li>
                        <li>
                            <span>Total Orders</span>
                            {data?.data?.totalOrder
                                ? data?.data?.totalOrder
                                : '0'}
                        </li>
                    </ul>
                </div>
            </div>

            <div className="tabbing-wrapper">
                <div className="admin-card tab-menu" id="nav-tab">
                    <ul>
                        <li className="tab-link">
                        </li>
                        <li className="tab-link">
                            <a
                                className={
                                    activeTab === 'orders' ? 'active' : ''
                                }
                                onClick={() => handleTabClick('orders')}
                            >
                                Orders
                            </a>
                        </li>
                        <li className="tab-link">
                            <a
                                className={
                                    activeTab === 'reviews' ? 'active' : ''
                                }
                                onClick={() => handleTabClick('reviews')}
                            >
                                Reviews
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="tab-content p-0" id="nav-tabContent">
               
                    <div
                        id="orders"
                        className={`tab-pane ${
                            activeTab === 'orders' ? 'active' : ''
                        }`}
                    >
                        <VendorOrderTab />
                    </div>
                    <div
                        id="reviews"
                        className={`tab-pane ${
                            activeTab === 'reviews' ? 'active' : ''
                        }`}
                    >
                        <VendorReviewTab />
                    </div>
                </div>
            </div>
            <DeleteModal
                message={
                    <>
                        Are you sure you want to <br /> Delete this User ?
                    </>
                }
                setIsDeleteModal={setIsDeleteModal}
                isDeleteModal={isDeleteModal}
                handleDelete={() => handleDelete(deleteId)}
            />
            {editbtn && (
                <FeesModal
                    editbtn={editbtn}
                    seteditbtn={seteditbtn}
                    getFees={getFees}
                    setFees={setFees}
                    userId={userId}
                />
            )}
        </>
    )
}

export default ViewBuyerDetails
